module.exports = __webpack_public_path__ + "static/media/facebook.25d01d0f.svg";